import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'clockHours',
  standalone: true,
})
export class ClockHoursPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string) {}

  transform(hours: number, shouldLocalize = false): string {
    return localize(hours, 0, shouldLocalize ? this.locale : '');
  }
}

export function localize(hours: number, minutes: number, locale: string): string {
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);

  // Format the date to display in the localized time format (e.g., "3:00 PM")
  return new DatePipe(locale).transform(date, 'shortTime') || '';
}
